<template>
  <b-row>
    <b-colxx class="disable-text-selection">
      <b-row>
        <b-colxx xxs="12">
          <h1>{{ $t('menu.goods-register-status') }}</h1>
          <piaf-breadcrumb/>
          <div class="separator mb-5"/>
        </b-colxx>
      </b-row>
      <b-card style="display: block;">
        <b-row class="mb-4">
          <b-colxx xxs="12" md="6" lg="5">
            <div class="has-float-label">
              <b-input-group class="mb-3">
                <b-form-input placeholder="상품명을 검색하세요" v-model="search" @keyup.enter="searchKeyword"/>
                <b-button v-show="!searchFlag" @click="searchKeyword" variant="outline-primary default" size="sm">
                  {{ $t('button.search') }}
                </b-button>
                <b-button v-show="searchFlag" @click="searchCancel" variant="outline-primary default" size="sm">
                  {{ $t('button.search-cancel') }}
                </b-button>
              </b-input-group>
              <span>상품명</span>
            </div>
          </b-colxx>
          <b-colxx xxs="12" md="6" lg="7">
            <div class="top-right-button-container">
              <b-button to="goods-register-request" variant="primary" size="lg" class="top-right-button">신규 상품 등록 신청
              </b-button>
              <b-dropdown id="ddown2" right :text="`${perPage}`" variant="outline-primary" class="d-inline-block"
                          size="md">
                <b-dropdown-item v-for="(size,index) in pageSizes" :key="index" @click="changePageSize(size)">{{ size }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </b-colxx>
        </b-row>

        <template v-if="isLoad">
          <b-row>
            <b-colxx sm="6" lg="6" xl="4" xxl="4" class="mb-3" v-for="(item,index) in items" :key="index" :id="item.registerId">

              <b-card style="display: block;" no-body>
                  <img style="width: 100%; height :230px; object-fit: cover;"
                       :src="item.mainImageUrl == null? '/assets/img/bebinca-thumb.jpg':item.mainImageUrl"
                       class="card-img-top" :alt="item.goodsName"/>
                  <h4>
                    <b-badge pill variant="primary" class="position-absolute badge-top-left">
                      {{ statusOptions[item.status] }}

                    </b-badge>
                  </h4>

                <b-card-body>
                  <b-row>
                    <b-colxx xxs="10" class="mb-1">
<!--                      여기-->
                      <h6 class="card-subtitle goodsName">{{ item.goodsName }}</h6>
                    </b-colxx>
                  </b-row>
                  <b-row>
                    <b-colxx align="center">
                      <b-button variant="outline-primary" size="sm" @click="copyItem(item)">복사</b-button>
                      <b-button v-if="item.status == 'RegisterRequested'" variant="primary" size="sm" type="button"
                                @click="cancelRequest(item)">요청취소
                      </b-button>
                      <b-button v-if="item.status == 'NoRequest' || item.status == 'RegisterDenied'" variant="primary"
                                size="sm" @click="modifyItem(item)">
                        수정
                      </b-button>
                      <b-button v-if="item.status == 'NoRequest' || item.status == 'RegisterDenied' " type="button"
                                variant="outline-primary" size="sm" @click="deleteItem(item)">
                        <b-icon icon="trash" scale="1.8"></b-icon>
                      </b-button>
                    </b-colxx>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-colxx>

            <b-colxx xxx="12" class="mb-3" v-if="items.length === 0 ">
              <b-card :class="{'d-flex flex-row':true }" no-body>
                <div class="pl-2 d-flex flex-grow-1 min-width-zero">
                  <div
                    class="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                    <h4 style="text-align:center;width:100%">조회 내용이 없습니다.</h4>
                  </div>
                </div>
              </b-card>
            </b-colxx>
          </b-row>

          <b-row v-if="lastPage > 1">
            <b-colxx xxs="12">
              <b-pagination
                size="sm"
                align="center"
                :total-rows="total"
                :per-page="perPage"
                v-model="currentPage"
              >
                <template v-slot:next-text>
                  <i class="simple-icon-arrow-right"/>
                </template>
                <template v-slot:prev-text>
                  <i class="simple-icon-arrow-left"/>
                </template>
                <template v-slot:first-text>
                  <i class="simple-icon-control-start"/>
                </template>
                <template v-slot:last-text>
                  <i class="simple-icon-control-end"/>
                </template>
              </b-pagination>

            </b-colxx>
          </b-row>
        </template>
        <template v-else>
          <div class="loading"></div>
        </template>
      </b-card>
    </b-colxx>
  </b-row>
</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import api from '../../constants/api'
import {
  mapGetters,
  mapActions
} from "vuex";

import ImageListItem from '../../components/Listing/ImageListItem'
import {
  apiUrl
} from '../../constants/config'

export default {
  components: {
    'v-select': vSelect,
    'image-list-item': ImageListItem,
  },
  data() {
    return {
      isLoad: false,
      search: '',
      searchFlag: false,
      currentPage: 1,
      perPage: 6,
      total: 0,
      lastPage: 0,
      items: [],
      pageSizes: [6, 9,12],
      sortBy: 'RegDate',
      direction: 'Descending',
      statusOptions: {
        'NoRequest': '임시저장',
        'RegisterRequested': '승인요청',
        'RegisterDenied': '승인거절',
        'RegisterApproved': '승인완료'
      },

    }
  },
  methods: {
    ...mapActions(['goodsReset', 'deleteReqGoods', 'cancelRequestGoods']),

    searchData() {

      this.goodsReset();
      this.isLoad = false

      const reqURL = api.changeAPI(this.siteName, api.basicURL + api.goods.registerPage)
      const params = {
        keywordType: 'GoodsNameContaining',
        keyword: this.search,
        pageNumber: this.currentPage - 1,
        pageSize: this.perPage,
      }

      this.$http.get(reqURL, {
        params: params,
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        if(res.data.code === "OK") {

          const _data = res.data.data
          this.total = _data.totalElements
          this.lastPage = _data.totalPages
          this.perPage = _data.size
          this.items = _data.content

        } else {
          throw 400
        }
      }).catch(err => {

      })
      this.isLoad = true
    },
    changePageSize(perPage) {
      this.currentPage = 1
      this.perPage = perPage
      this.searchData()
    },


    clickItem(event, itemId) {
      this.$router.push('goods-register-request')
    },


    copyItem(item) {
      this.$router.push(`goods-copy-register-request/${item.registerId}`)
    },


    modifyItem(item) {
      this.$router.push(`goods-register-request/${item.registerId}`)
    },


    deleteItem(item) {
      if(confirm("삭제하시겠습니까? ")) {
        this.deleteReqGoods({currentUser: this.currentUser, siteName: this.siteName, registerId: item.registerId})
        this.$router.go(0)
      }
    },


    cancelRequest(item) {
      this.cancelRequestGoods({currentUser: this.currentUser, siteName: this.siteName, registerId: item.registerId})
      this.$router.go(0)

    },


    searchKeyword() {
      if(this.search === null || this.search === "") {
        alert('상품명을 입력해주세요.');
        return false
      }
      this.searchData()
      this.searchFlag = true
    },
    searchCancel() {
      this.search = ''
      this.searchFlag = false
      this.searchData()
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'siteName'])
  },
  watch: {

    currentPage() {
      this.searchData()
    },
  },
  mounted() {
    this.searchData()
  }
}
</script>
<style>
.goodsName {
  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: keep-all;
  min-height: 38.39px;
}
</style>

